import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-login-platform",
  "use": "icon-login-platform-usage",
  "viewBox": "0 0 1081 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1081 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-login-platform\"><path fill=\"#409EFF\" d=\"M1014.673091 0H66.707676A66.775262 66.775262 0 0 0 0 66.707676v683.973335a66.775262 66.775262 0 0 0 66.707676 66.707676h424.779883V939.449541H78.264933a42.241436 42.241436 0 0 0 0 84.415286h910.725365a42.241436 42.241436 0 0 0 0-84.415286H575.902845v-121.993267h438.770246a66.775262 66.775262 0 0 0 66.707676-66.707677V66.707676A66.775262 66.775262 0 0 0 1014.673091 0z m-17.70761 733.040987h-912.415022v-648.82846h912.415022v648.82846z\" /><path fill=\"#409EFF\" d=\"M295.284536 338.810112h197.487162a42.241436 42.241436 0 1 0 0-84.415287H295.284536a42.241436 42.241436 0 1 0 0 84.415287z m0 219.114777h522.374496a42.241436 42.241436 0 0 0 0-84.415286H295.284536a42.241436 42.241436 0 1 0 0 84.415286z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/login-platform.svg
// module id = r//b
// module chunks = 132